import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'

const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormPriceRank = ({onChange, overlayContentRef, type, wrapper, value}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {DEFAULT_PRICE_RANK_SEARCH, DEFAULT_PRICE_RANK_SEARCH_REQUEST_VALUE, FILTER_NAMES} = config.get('searchFilters')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const handleChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.PRICE_RANK,
      value: value === CHECKED_ID ? DEFAULT_PRICE_RANK_SEARCH_REQUEST_VALUE : DEFAULT_PRICE_RANK_SEARCH,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.PRICE_RANK]
    })
  }

  const handleCheck = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    handleChange(null, {value: currentValue})
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('FILTER.PRICE_RANK.LABEL'),
          name: FILTER_NAMES.PRICE_RANK,
          options: [{id: CHECKED_ID, label: i18n.t('FILTER.PRICE_RANK.LABEL')}],
          type
        }
      ]}
      group={`${FILTER_NAMES.PRICE_RANK}Group`}
      helpText={i18n.t('FILTER.PRICE_RANK.HELP_TEXT')}
      legend={i18n.t('FILTER.PRICE_RANK.LABEL')}
      onChange={handleCheck}
      overlayContentRef={overlayContentRef}
      value={{[FILTER_NAMES.PRICE_RANK]: [value.length ? CHECKED_ID : UNCHECKED_ID]}}
      wrapper={wrapper}
    />
  )
}

FormPriceRank.displayName = 'FormPriceRank'
FormPriceRank.propTypes = {
  type: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  wrapper: PropTypes.string
}

export default FormPriceRank
